import type { Flag } from '~/shared/api/data-ingestion-api/client'

import { getFlagResolution } from './flag-comments'

/** Returns the most recently resolved flag of the given type, or null. */
export function getLatestResolvedFlagByType(flags: Flag[], flagType: string): Flag | null {
  const resolved = flags
    .filter((flag) => flag.flag_type === flagType && flag.flag_status === 'resolved')
    .sort((a, b) => {
      const dateA = getFlagResolution(a)?.created_at ?? ''
      const dateB = getFlagResolution(b)?.created_at ?? ''
      return dateB.localeCompare(dateA)
    })

  return resolved[0] ?? null
}
